export default function NumberToWords(num: number): string {
  if (num === 0) return "Zero Only";

  const belowTwenty = [
    "",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];
  const tens = [
    "",
    "",
    "Twenty",
    "Thirty",
    "Forty",
    "Fifty",
    "Sixty",
    "Seventy",
    "Eighty",
    "Ninety",
  ];
  const thousands = ["", "Thousand", "Lakh", "Crore"];

  function helper(n: number): string {
    if (n === 0) return "";
    if (n < 20) return belowTwenty[n] + " ";
    if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
    if (n < 1000)
      return belowTwenty[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
    return "";
  }

  function convertInteger(integer: number): string {
    let res = "";
    let i = 0;
    const parts: number[] = [];

    parts.push(integer % 1000);
    integer = Math.floor(integer / 1000);

    while (integer > 0) {
      if (i === 0) {
        parts.push(integer % 100);
        integer = Math.floor(integer / 100);
      } else {
        parts.push(integer % 100);
        integer = Math.floor(integer / 100);
      }
      i++;
    }

    for (let j = parts.length - 1; j >= 0; j--) {
      if (parts[j] !== 0) {
        res += helper(parts[j]) + thousands[j] + " ";
      }
    }

    return res.trim();
  }

  // const fixed = parseFloat(num);
  const fixed = num;
  const integerPart = Math.floor(fixed);
  const decimalPart = Math.round((fixed - integerPart) * 100); // paise

  let result = convertInteger(integerPart);

  if (decimalPart > 0) {
    result += ` and ${convertInteger(decimalPart)} Paise`;
  }

  return result + " Only";
}
